<form [formGroup]="storeForm">
  <p-sidebar
    [(visible)]="visible"
    position="right"
    styleClass="w-screen lg:w-4"
    (onShow)="onShow()"
    [showCloseIcon]="false"
    [dismissible]="false"
  >
    <!-- Start::header -->
    <ng-template pTemplate="header">
      <div class="flex align-items-center w-full justify-content-between">
        <span class="font-bold text-lg"> Seleccione una tienda </span>
        <i
          class="fa-sharp fa-solid fa-xmark text-xl cursor-pointer"
          style="padding-top: 1px"
          (click)="showCloseConfirmation()"
        ></i>
      </div>
    </ng-template>
    <!-- End::header -->

    <ng-template pTemplate="content">
      <div class="flex flex-column field p-0 gap-3">
        <p-dropdown
          [options]="stores"
          formControlName="code"
          optionLabel="name"
          optionValue="code"
          placeholder="Selecciona una tienda"
          styleClass="w-full"
          (onChange)="onSelectStore($event)"
          [filter]="true"
          filterBy="name"
        >
          <ng-template pTemplate="selectedItem">
            <div class="flex flex-column">
              <div class="font-semibold mb-1">
                {{ selectedStore?.name }}
              </div>
              <span class="text-sm overflow-hidden text-overflow-ellipsis">
                {{ selectedStore?.address }}
              </span>
            </div>
          </ng-template>
          <ng-template let-store pTemplate="item">
            <div class="flex flex-column align-items-start">
              <div class="font-semibold mb-1">{{ store.name }}</div>
              <span class="text-sm">{{ store.address }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <app-map-v2 (isMapReady)="onMapReady()" />
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end">
        <p-button
          label="Seleccionar"
          class="w-full"
          styleClass="w-full"
          (onClick)="showSelectStoreConfirmation()"
        />
      </div>
    </ng-template>
  </p-sidebar>
</form>

<p-confirmDialog />
